module.exports = __webpack_public_path__ + "img/logo_onebox-horizontal-png.3a433fac.png";